var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-view",
    [
      _c("footer-navigation", {
        attrs: { "current-page": _vm.Resources.Layout.FeesLink },
      }),
      _vm._v(" "),
      _c("base-hero", {
        attrs: {
          title: "Fees",
          description:
            "Easily fund and manage your campaign. Exclusive features at no extra cost.",
          type: "fees",
        },
      }),
      _vm._v(" "),
      _c(
        "main",
        {
          staticClass:
            "gfu-layout-wrapper gfu-layout-wrapper--narrow _py-6 js-main-content",
        },
        [
          _c(
            "box",
            { staticClass: "_tac _mb-6", attrs: { main: true, huge: true } },
            [
              _c("h2", { staticClass: "gfu-hd gfu-hd--h2" }, [
                _vm._v("Exclusive benefits "),
                _c("span", { staticClass: "_fw-n" }, [
                  _vm._v("for your project."),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "_flexwrap _my-6" }, [
                _c(
                  "div",
                  { staticClass: "gfu-1of2 gfu-1of4--l _flexcol _pa-2" },
                  [
                    _c(
                      "tooltip",
                      { attrs: { text: "Lots of tools to help you succeed." } },
                      [
                        _c("base-icon", {
                          staticClass: "_tc--accent",
                          attrs: { name: "gears", size: "2x" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("h4", { staticClass: "gfu-hd gfu-hd--h4 _mt-2" }, [
                      _vm._v("Advanced features"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "gfu-1of2 gfu-1of4--l _flexcol _pa-2" },
                  [
                    _c(
                      "tooltip",
                      {
                        attrs: {
                          text: "Various payment methods, free installments, and many more.",
                        },
                      },
                      [
                        _c("base-icon", {
                          staticClass: "_tc--accent",
                          attrs: { name: "shopping-cart", size: "2x" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("h4", { staticClass: "gfu-hd gfu-hd--h4 _mt-2" }, [
                      _vm._v("Great checkout"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "gfu-1of2 gfu-1of4--l _flexcol _pa-2" },
                  [
                    _c(
                      "tooltip",
                      { attrs: { text: "Reach millions of backers!" } },
                      [
                        _c("base-icon", {
                          staticClass: "_tc--accent",
                          attrs: { name: "users", size: "2x" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("h4", { staticClass: "gfu-hd gfu-hd--h4 _mt-2" }, [
                      _vm._v("Huge community"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "gfu-1of2 gfu-1of4--l _flexcol _pa-2" },
                  [
                    _c(
                      "tooltip",
                      {
                        attrs: {
                          text: "Our team shares their expert knowledge for free.",
                        },
                      },
                      [
                        _c("base-icon", {
                          staticClass: "_tc--accent",
                          attrs: { name: "messages-question", size: "2x" },
                        }),
                        _vm._v(" "),
                        _c("h4", { staticClass: "gfu-hd gfu-hd--h4 _mt-2" }, [
                          _vm._v("Premium support"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "base-button",
                { attrs: { tag: "a", href: _vm.becomeACreatorUrl } },
                [_vm._v("Learn more")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("h2", { staticClass: "gfu-hd gfu-hd--h2" }, [_vm._v("Our offer")]),
          _vm._v(" "),
          _c("div", { staticClass: "gfu-bt gfu-bt--b1" }, [
            _vm._v(
              "Complex crowdfunding and pledge manager services depending on your needs. No hidden fees."
            ),
          ]),
          _vm._v(" "),
          _c(
            "box",
            { staticClass: "_my-6", attrs: { main: true, huge: true } },
            [
              _vm._l(_vm.items, function (item) {
                return _c("div", { key: item.title }, [
                  _c("hr", { staticClass: "gfu-hr gfu-hr--light" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "_flexwrap _ai-c" }, [
                    _c(
                      "div",
                      {
                        staticClass: "gfu-1of1 gfu-3of4--m _pa-3 _tac _tal--l",
                      },
                      [
                        item.badge
                          ? _c(
                              "base-badge",
                              { attrs: { theme: item.badge.theme } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(item.badge.text) +
                                    "\n                        "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("h4", { staticClass: "gfu-hd gfu-hd--h3" }, [
                          _vm._v(_vm._s(item.title)),
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "gfu-bt gfu-bt--b1",
                          domProps: { innerHTML: _vm._s(item.description) },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "gfu-1of1 gfu-1of4--m _tac _pa-3" },
                      [
                        _c(
                          "h4",
                          { staticClass: "gfu-hd gfu-hd--h2 _tc--accent" },
                          [_vm._v(_vm._s(item.value))]
                        ),
                        _vm._v(" "),
                        item.valueDescription
                          ? _c("div", [_vm._v(_vm._s(item.valueDescription))])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ])
              }),
              _vm._v(" "),
              _c("hr", { staticClass: "gfu-hr gfu-hr--light _mb-6" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "_tac" },
                [
                  _c(
                    "base-button",
                    { attrs: { tag: "a", href: _vm.launchYourProjectUrl } },
                    [_vm._v("Launch your project")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }